/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2023-08-16 08:53:31
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-09-19 09:52:09
 */
const myMixin = {
  data () {
    return {
      timestamp: "",
      numRandom: "",
      mainSign: "",
      thisToken: "WEKJGHDFDFNL",

      unitList: {
        1: '亩',
        2: '平方米',
        3: '公顷',
        4: '台',
        5: '方',
        6: '颗',
        7: '斤',
        8: '公斤',
        9: '辆',
        10: '米',
        11: '个',
        12: '眼',
        13: '口',
        14: '套',
        15: '间',
        16: '棵',
        17: '头',
        18: '座',
      },
      priceUnitList: {
        5: "元/平方米/年",

        4: "元/亩",

        3: "元（总价）",

        2: "元/年",

        1: "元/亩/年"
      }
    }
  },
  created () {
    this.timestamp = (Date.parse(new Date()) / 1000).toString()
    this.numRandom = Math.floor(Math.random() * 999999).toString()
    this.mainSign = this.$md5(this.thisToken + this.numRandom + this.timestamp)
    // console.log(this.mainSign);
    // let search = window.location.search;
    // console.log(search);
    // if (search) {
    //   console.log(search.substr(4));
    // }
    // localStorage.removeItem("deptId");
    // localStorage.removeItem("deptName");
    let search = window.location.search
    // console.log(search);
    // if (search) {
    //   let arr = search.split("&");
    //   console.log(arr);
    //   let deptId = arr[0].match(/=(\S*)/)[1] ? arr[0].match(/=(\S*)/)[1] : 1;
    //   let deptName = arr[1].match(/=(\S*)/)[1];
    //   console.log(deptId);
    //   console.log(decodeURIComponent(deptName));

    //   localStorage.setItem("deptId", deptId);
    //   localStorage.setItem("deptName", decodeURIComponent(deptName));
    // } else {
    //   localStorage.setItem("deptName", this.cityDetail.cityName);
    // }
  }
}
export default myMixin
